import { render, staticRenderFns } from "./yesMermaid.vue?vue&type=template&id=2423574f"
import script from "./yesMermaid.vue?vue&type=script&lang=js"
export * from "./yesMermaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports